import { render, staticRenderFns } from "./SPage.vue?vue&type=template&id=117ec1b2&lang=pug&"
import script from "./SPage.vue?vue&type=script&lang=ts&"
export * from "./SPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageBreadcrumbs: require('/var/www/linza-front/linza-front-20251114081013/node_modules/sitis-nuxt/lib/cms/PageBreadcrumbs.vue').default})
